import React from 'react';
import { Link } from 'react-router-dom';

function SmsConsentPage() {
  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <div className="relative overflow-hidden border-b border-white/10 bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800">
        <div className="absolute inset-0 opacity-30">
          <div className="absolute -top-24 right-0 h-72 w-72 rounded-full bg-cyan-500 blur-3xl" />
          <div className="absolute bottom-0 left-0 h-72 w-72 rounded-full bg-sky-500 blur-3xl" />
        </div>
        <div className="relative mx-auto max-w-5xl px-6 py-20 md:px-10 md:py-24">
          <div className="max-w-3xl">
            <p className="mb-4 inline-flex rounded-full border border-cyan-400/30 bg-cyan-400/10 px-4 py-1 text-sm font-semibold text-cyan-200">
              SMS Consent
            </p>
            <h1 className="text-4xl font-bold tracking-tight md:text-6xl">
              Clear SMS consent for estimates, scheduling, and project updates
            </h1>
            <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-300">
              SwiftBid Pro and Happy Home Painter use SMS to communicate with customers and leads who request contact about painting estimates, scheduling, appointment reminders, quote updates, and project-related communication.
            </p>
          </div>
        </div>
      </div>

      <main className="mx-auto max-w-5xl px-6 py-16 md:px-10">
        <section className="grid gap-8 md:grid-cols-2">
          <div className="rounded-3xl border border-white/10 bg-white/5 p-8 shadow-2xl shadow-cyan-950/20 backdrop-blur">
            <h2 className="text-2xl font-semibold text-white">How consent works</h2>
            <div className="mt-4 space-y-4 text-slate-300">
              <p>
                Customers opt in verbally during a phone call or in-person estimate intake before any text messages are sent. During that process, we ask for consent to send text messages related to estimates, scheduling, reminders, and project updates.
              </p>
              <p>
                We only send SMS messages after the customer says yes. Consent is recorded in our CRM.
              </p>
              <p>
                Message frequency varies depending on the customer&apos;s project activity. Message and data rates may apply.
              </p>
            </div>
          </div>

          <div className="rounded-3xl border border-white/10 bg-slate-900/80 p-8 shadow-2xl shadow-slate-950/30">
            <h2 className="text-2xl font-semibold text-white">Verbal consent script</h2>
            <blockquote className="mt-4 rounded-2xl border-l-4 border-cyan-400 bg-white/5 p-6 text-slate-200">
              "Do you agree to receive text messages from Happy Home Painter about your estimate, scheduling, appointment reminders, and project updates? Message frequency varies. Message and data rates may apply. Reply STOP to opt out and HELP for help."
            </blockquote>
            <p className="mt-4 text-sm leading-6 text-slate-400">
              This script is meant to be used before the first SMS is sent so the customer understands what they are opting into.
            </p>
          </div>
        </section>

        <section className="mt-8 grid gap-8 md:grid-cols-2">
          <div className="rounded-3xl border border-white/10 bg-white p-8 text-slate-900 shadow-xl">
            <h2 className="text-2xl font-semibold">Twilio-friendly copy</h2>
            <p className="mt-4 leading-7 text-slate-700">
              Customers opt in verbally by phone or in person before receiving SMS messages from Happy Home Painter. Messages are used for estimates, scheduling, reminders, quote updates, and project communication. Message frequency varies. Message and data rates may apply. Reply STOP to opt out and HELP for help. Consent is recorded in our CRM and is not shared with third parties for marketing purposes.
            </p>
          </div>

          <div className="rounded-3xl border border-white/10 bg-white/5 p-8 shadow-2xl shadow-cyan-950/20">
            <h2 className="text-2xl font-semibold text-white">Opt out and help</h2>
            <div className="mt-4 space-y-4 text-slate-300">
              <p>
                You can opt out at any time by replying STOP.
              </p>
              <p>
                For help, reply HELP or contact us through our website.
              </p>
              <p>
                SMS consent is not shared with third parties or affiliates for marketing purposes.
              </p>
            </div>
          </div>
        </section>

        <section className="mt-8 rounded-3xl border border-cyan-400/20 bg-cyan-400/10 p-8">
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <div>
              <h2 className="text-2xl font-semibold text-white">Need the legal pages too?</h2>
              <p className="mt-2 text-slate-300">
                We also reference SMS consent in our privacy policy and terms so the language stays consistent across the site.
              </p>
            </div>
            <div className="flex gap-3">
              <Link to="/privacy-policy" className="rounded-xl border border-white/15 px-4 py-2 text-sm font-semibold text-white transition hover:bg-white/10">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="rounded-xl border border-white/15 px-4 py-2 text-sm font-semibold text-white transition hover:bg-white/10">
                Terms of Service
              </Link>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default SmsConsentPage;
